import React from 'react';

enum FontColors {
  WHITE = 'WHITE',
  GREY = 'GREY',
  PURPLE = 'PURPLE',
  BLACK = 'BLACK',
  GREEN = 'GREEN',
}

enum HeadingTag {
  H2 = 2,
  H3 = 3,
  H4 = 4,
  H5 = 5,
}

enum Position {
  CENTER = 'center',
  RIGHT = 'right',
  LEFT = 'left',
}

const baseClassName = {
  container: 'grid grid-cols-24',
  description: 'font-headline col-start-2 col-end-24',
};

const classNames = {
  [FontColors.BLACK]: `${baseClassName.description} text-black`,
  [FontColors.WHITE]: `${baseClassName.description} text-white`,
  [FontColors.GREY]: `${baseClassName.description} text-grey100`,
  [FontColors.GREEN]: `${baseClassName.description} text-green60`,
  [FontColors.PURPLE]: `${baseClassName.description} text-purple80`,
};

export type HeadingProps = {
  description: string;
  fontColor: FontColors;
  headingTag: HeadingTag;
  position: Position;
};

export default function Heading({
  description,
  fontColor,
  headingTag,
  position,
}: HeadingProps) {
  const HeadingElement = `h${headingTag}` as keyof JSX.IntrinsicElements;

  return (
    <div className={baseClassName.container}>
      <HeadingElement className={`${classNames[fontColor]} text-${position}`}>
        {description}
      </HeadingElement>
    </div>
  );
}
